























































































import Vue from "vue";
import StandartCard from "@/components/Card/StandartCard/StandartCard.vue";
import { store } from "@/store/store";
import Paragraph from "@/components/Text/Global/Paragraph.vue";
import { Device } from "@/store/modules/Device/interface";
import { Survey } from "@/store/modules/Survey/interface";
import { Poste } from "@/store/modules/Poste/interface";
import NavbarTitle from "@/components/Text/Navbar/NavbarTitle.vue";
import router from "@/router/router";
import Utils from "@/utils/utils";
import Map from "@/components/Map/Map.vue";
import { IMapDataDefinition } from "@/types/types";

interface PosteDescriptionData {
  poste: Poste;
  material: Device | undefined;
  survey: Survey | null;
}

export default Vue.extend({
  name: "PosteDescription",
  components: { StandartCard, Paragraph, Map, NavbarTitle },
  created(): void {
    if (!store.getters.POSTE_BY_ID[this.$route.query.posteId as string]) router.push({ path: "/devices" });
  },
  data(): PosteDescriptionData {
    return {
      poste: store.getters.POSTE_BY_ID[this.$route.query.posteId as string],
      material: undefined,
      survey: null
    };
  },
  beforeMount(): void {
    this.material = this.poste_format_material;
    this.survey = this.poste_format_survey;
  },
  methods: {
    goBack(): void {
      router.go(-1);
    }
  },
  computed: {
    poste_format_material(): Device | undefined {
      const material: Device = { ...store.getters.DEVICE_BY_ID[this.poste.material] };
      if (Object.keys(material).length === 0) return undefined;
      material.agence = store.getters.AGENCE_BY_ID[material.agence].name;
      material.category = store.getters.CATEGORY_BY_ID[material.category].name;
      return material;
    },
    poste_format_survey(): Survey {
      const survey: Survey = { ...store.getters.SURVEY_BY_ID[this.poste.survey] };
      survey.user = store.getters.USER_BY_ID[survey.user].mail;
      survey.agence = store.getters.AGENCE_BY_ID[survey.agence].name;
      survey.start_date = Utils.transformDateToYMD(survey.start_date);
      survey.end_date = Utils.transformDateToYMD(survey.end_date);
      return survey;
    },
    map_datas(): IMapDataDefinition {
      return {
        ...this.poste,
        name: this.poste.name_poste,
        location: this.poste.real_location
      };
    }
  }
});
